<template>
    <section class="rrl-hero">
        <h1 class="rrlh-claim">
            Nebaví vás otevírat aplikaci
            pro správu <span class="rr-primary-color">rezervací</span>?
        </h1>
    </section>
</template>
<script>
export default {
    name: "LandingHero"
}
</script>
<style scoped lang="scss">
    .rrl-hero {
        min-height: 70vh;
        position: relative;

        background-image: url("../../../../resources/images/heroimg.png");
        background-repeat: no-repeat;
        background-size: 60vh;
        background-position: right bottom;
        h1.rrlh-claim {
            font-size: 5rem;
            max-width: 50%;
            line-height: 5rem;
            position: absolute;
            bottom:0;
        }
    }
</style>
